var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveysBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1665 10.4167H2.1665V12.5H15.1665V10.4167ZM15.1665 6.25H2.1665V8.33333H15.1665V6.25ZM2.1665 16.6667H10.8332V14.5833H2.1665V16.6667ZM23.2915 11.9792L24.9165 13.5417L17.344 20.8333L12.4582 16.1458L14.0832 14.5833L17.344 17.7083L23.2915 11.9792Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveysBase);
export default __webpack_public_path__ + "static/media/surveys_base.02cf99e196f62f579b50bbfe60158373.svg";
export { ForwardRef as ReactComponent };